import { PencilIcon, TrashIcon } from "@heroicons/react/20/solid";

import { useContext, useEffect, useState } from "react";
import SharedDataContext from "../../../SharedDataContext";
import { paginationConfig } from "../../../axios/constant";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { isEmptyObject, returnArray } from "../../../utils/GenericFn";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import Pagination from "../../Pagination";
import EditColumn from "../../EditColumn";
import Filter from "../../Filter";
import useUpdateQuery from "../../../hooks/useUpdateQuery";
import TableLoader from "../../Loaders/TableLoader";
import NoData from "../../NoData";
import { toast } from "react-hot-toast";
import { Tooltip } from "react-tooltip";
import ConfirmModal from "../../Modals/ConfirmModal";
import { deleteTeam, getTeams } from "../../../apis/workspace/teams";
import TeamModal from "./TeamModal";
import NavAnchor from "../../Tags/NavAnchor";
import Image from "../../Tags/Image";
import GenericModal from "../../GenericModal";
import useModal from "../../GenericModal/useModal";
import useRoleCheck from "../../../hooks/useRoleCheck";
import PrintDate from "../../Tags/PrintDate";
import { Button } from "../../ui/button";
import { ArrowDown, PlusIcon } from "lucide-react";
import Text from "../../Tags/Text";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import { useTableData } from "../../../hooks/useTableData";
import { getMembers } from "../../../apis/workspace/members";
import PageHeader from "../../PageHeader";
export default function Teams() {
  const captureEvent = useCaptureEvent();
  const { activeWorkspace } = useRoleCheck();
  const queryClient = useQueryClient();
  const [teams, setTeams] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const {
    data,
    paginationInfo,
    filterMetadata,
    columnMetadata,
    apiResponse,
    isLoading,
    isFetching,
    isFetched,
    isSuccess,
    isError,
    filters,
    sort,
    pagination,
    columns,
    sortedVisibleColumns,
    getPageNumber,
    getFiltersObject,
    handleSetSort,
    getColumns,
  } = useTableData({
    queryKey: "get_teams",
    fetchFn: getTeams,
    defaultHeaders: { "X-Workspace-Id": activeWorkspace?.id },
    enabled: !!activeWorkspace?.id,
    onSuccess: (data) => {
      //   const mappedData = mapApiResponseToTableData(data);
      console.log("data", data);
      setTeams(data);
      setIsInitialLoad(false);

      console.log("Fetched!", data);
    },
    onError: (error) => {
      console.error("CallLogs API error:", error);
      if (error?.status === 403 || error?.response?.status === 403) {
        setIsInitialLoad(false);
      } else {
      }
    },
  });

  const renderCellContent = (columnKey, item) => {
    switch (columnKey) {
      case "name":
        return (
          <>
            <NavAnchor to={`/settings/teams/${item?.id}`} className="text-brand-700 font-semibold">
              {item?.[columnKey]}
            </NavAnchor>
          </>
        );
      case "created_by":
        return (
          <div className="flex items-center">
            <div className="h-9 w-9 flex-shrink-0">
              <Image
                nobaseurl
                className="h-9 w-9 rounded-full"
                src={item?.[columnKey]?.profile_photo_url}
                alt=""
              />
            </div>
            <div className="ml-4">
              <div className="font-medium ">{item?.[columnKey]?.name}</div>
              <div className="mt-0 text-gray-500">{item?.[columnKey]?.email}</div>
            </div>
          </div>
        );
      case "members":
        return item?.[columnKey]?.length;

      case "created_at":
        return <PrintDate date={item?.created_at} showTime={true} />;
      default:
        return item?.[columnKey] || "-";
    }
  };
  // getTeamMembers
  const [teamMembers, setTeamMembers] = useState([]);
  const teamMembersFn = useQuery(
    ["get_team_members"],
    () => {
      return getMembers({
        query: "per_page=100", // Get more members for dropdown
        options: {
          headers: {
            "X-Workspace-Id": activeWorkspace?.id,
          },
        },
      });
    },
    {
      enabled: !!activeWorkspace?.id,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        const membersArray = data?.data || [];
        setTeamMembers(membersArray);
      },
      onError: (error) => {
        console.error("Error fetching members:", error);
        // Fallback to mock data on error
      },
    }
  );

  console.log("teamMembers", teamMembers);

  // handle edit team
  const [teamEditMode, setTeamEditMode] = useState(false);
  const [currentTeam, setCurrentTeam] = useState({});
  // handle delete team
  const [currentTeamId, setCurrentTeamId] = useState("");
  const deleteTeamFn = useMutation("delete_team", deleteTeam, {
    onSuccess(data, variables, context) {
      toast.success(data?.message);
      queryClient.invalidateQueries("get_teams");
    },
  });
  const handleDeleteTeam = () => {
    deleteTeamFn.mutate({
      teamId: currentTeamId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  // handle open confirm
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openConfirmModalType, setOpenConfirmModalType] = useState("");
  const confirmModalState = (data) => {
    setOpenConfirmModal(data.false);
    //console.log(data);
    if (data && data.confirm && data.type && data.type === "delete") {
      handleDeleteTeam();
    }
  };

  // handle open group modal
  const { isOpen, openModal, closeModal } = useModal();

  return (
    <>
      <PageHeader
        heading="Teams"
        description="Create teams to monitor, set product limits and managing permissions"
        cta={
          <Button
            onClick={() => {
              openModal();
              captureEvent("SET_Groups_CreateGroupBtn");
            }}
            type="button"
          >
            <PlusIcon className="h-5 w-5 mr-2" aria-hidden="true" />
            Create new team
          </Button>
        }
      />

      {teams?.data && (teams.data.length > 0 || !isEmptyObject(filters)) && (
        <div className="flex justify-between items-center mt-4">
          <div className="space-x-3 inline-flex items-center">
            {teams.filterMetadata && (
              <>
                <span className="text-sm text-gray-500">Filters:</span>
                <Filter filterMetadata={teams.filterMetadata} getFiltersObject={getFiltersObject} />
              </>
            )}
          </div>
          <div className="space-x-3">
            {teams.columnMetadata && (
              <EditColumn columnMetadata={teams.columnMetadata} getColumns={getColumns} />
            )}
          </div>
        </div>
      )}
      {teams?.data && teams.data.length > 0 && isSuccess && (
        <div className="mt-6 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden border border-border rounded-[--radius]">
                <table className="min-w-full divide-y divide-border table-fixed">
                  <thead className="bg-gray-100">
                    <tr>
                      {returnArray(sortedVisibleColumns).map((column, index) => (
                        <th
                          key={index}
                          scope="col"
                          className={`px-3 py-3.5 text-left text-xs font-medium text-text-600 ${
                            column.key === "user_name" ? "w-1/4" : ""
                          } ${column.sortable ? "cursor-pointer" : ""}`}
                          onClick={() => (column.sortable ? handleSetSort(column.key) : void 0)}
                        >
                          <span className={"inline-flex items-center"}>
                            {column.display_name}
                            {column.sortable && (
                              <>
                                {sort === `-${column.key}` ? (
                                  <ArrowDown className="inline-block ml-1 h-3 w-3" />
                                ) : sort === column.key ? (
                                  <ArrowUp className="inline-block ml-1 h-3 w-3" />
                                ) : (
                                  <ArrowDown className="inline-block ml-1 h-3 w-3 opacity-50" />
                                )}
                              </>
                            )}
                          </span>
                        </th>
                      ))}
                      <th scope="col" className="!px-3 !py-4 text-left text-sm font-medium" />
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border bg-background">
                    {teams.data &&
                      teams.data.length > 0 &&
                      returnArray(teams.data).map((item, index) => (
                        <tr key={item.id} className={`hover:bg-gray-50  ${index % 2 !== 0 ? "" : ""}`}>
                          {returnArray(sortedVisibleColumns).map(({ key: colKey }) => (
                            <td
                              key={colKey}
                              className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-[#F7F7F7] "
                            >
                              {renderCellContent(colKey, item)}
                            </td>
                          ))}
                          <td className="whitespace-nowrap  px-3 py-4">
                            <div className="flex justify-end w-full">
                              <Button
                                data-tooltip-id="in_table_actions"
                                data-tooltip-content="Edit"
                                variant="ghost"
                                onClick={() => {
                                  setTeamEditMode(true);
                                  setCurrentTeam(item);
                                  openModal();
                                }}
                              >
                                <Image
                                  src="/images/icons/untitledui/edit.svg"
                                  width="16"
                                  height="16"
                                  className="inline-block"
                                />
                              </Button>
                              <Button
                                data-tooltip-id="in_table_actions"
                                data-tooltip-content="Delete"
                                variant="ghost"
                                onClick={() => {
                                  setCurrentTeamId(item?.id);
                                  setOpenConfirmModal(true);
                                  setOpenConfirmModalType("delete");
                                }}
                              >
                                <Image
                                  src="/images/icons/untitledui/trash.svg"
                                  width="16"
                                  height="16"
                                  className="inline-block"
                                />
                              </Button>
                              <Tooltip id="in_table_actions" />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {(isLoading || isInitialLoad) && <TableLoader />}

      {teams?.data?.length === 0 && !isLoading && !isError && <NoData title="No data found" description="" />}

      {/* Pagination */}
      <div className="flex items-center justify-between rounded-[--radius] py-3">
        <div className="flex-1">
          {teams.pagination && teams.pagination.total > 0 && (
            <Pagination data={teams.pagination} getPageNumber={getPageNumber} />
          )}
        </div>
      </div>

      <ConfirmModal
        openModal={openConfirmModal}
        modalType={openConfirmModalType}
        confirmModalState={confirmModalState}
      />
      <GenericModal
        isOpen={isOpen}
        closeModal={() => {
          closeModal();
          setTeamEditMode(false);
          setCurrentTeam({});
        }}
      >
        <TeamModal
          closeModal={() => {
            closeModal();
            setTeamEditMode(false);
          }}
          activeWorkspace={activeWorkspace}
          edit={teamEditMode}
          data={currentTeam}
          teamMembers={teamMembers}
        />
      </GenericModal>
    </>
  );
}
